import React from 'react';
import {Button} from 'antd';
import {marginBottom, marginLeft, marginTop} from "../../common/script";


export default class ProductsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            detailList: [{
                title: 'Aviation FBA transportation',
                info: [
                    'Provide market price reference, participate in bidding for goods collection by enterprises, and send them to designated overseas warehouses.',
                    'Paid warehousing services.'
                ],
                img: 'https://qiniu.mrcargo.com/zs_product_index_1.png',
            }, {
                title: 'Cross-border e-commerce import',
                info: [
                    'Overseas transportation arrangement.',
                    'Import declaration of food, red wine, cosmetics, etc.',
                    'Labeling service, commodity pre-classification, agency inspection and quarantine.',
                    'Services of bonded, warehousing and distribution.',
                ],
                img: 'https://qiniu.mrcargo.com/zs_product_index_2.png',
            }, {
                title: 'Import and distribution of fresh food',
                info: [
                    'Overseas transportation arranges the import of seafood, fruits and frozen products.',
                    'Customs declaration, bonded, warehousing and cold chain distribution.',
                ],
                img: 'https://qiniu.mrcargo.com/zs_product_index_3.png',
            }]
        }
    }


    render() {
        return (<div>
                <div style={{position: 'relative'}} className={'flex-row width100p'}>
                    <img src={'https://qiniu.mrcargo.com/zs_product_banner.png'} alt={'zs_product_banner'}
                         className={'width100p'}/>
                    <div className={'width100p first-context font-size64 text-center'} style={marginTop(10)}>
                        <span className={'colorfff'}>Our Products</span>
                    </div>
                </div>

                {
                    this.state.detailList.map((item, index) => {
                        return <div key={`detailList${index}`}
                                    style={index % 2 === 1 ? {position: 'relative'} : marginBottom(5)}
                                    className={'flex-row width100p'}>
                            {
                                index % 2 === 1 ? <img src={'https://qiniu.mrcargo.com/zs_product_index_bg.png'}
                                                       alt={'zs_product_index_bg'}
                                                       className={'width100p'}/> : ''
                            }
                            <div style={marginTop(10)}
                                 className={`width100p ${index % 2 === 1 ? 'first-context' : ''}`}>
                                <div className={'flex-row font-size32 color0D182B justify-center font-bold'}>
                                    <div>0{index + 1}</div>
                                    <div style={marginLeft(3)}>{item.title}</div>
                                </div>
                                <div className={`width100p flex-row justify-center ${index % 2 === 1 ? 'flex-row-reverse' : ''}`}
                                    style={marginTop(6)}>
                                    <div style={Object.assign({width:'30%'},marginLeft(3))}>
                                        {
                                            item.info.map((itemInfo, infoIndex) => {
                                                return <div key={`info${infoIndex}`} style={Object.assign({display: 'flex'},marginTop(2))}>
                                                    <div className={'dot-view'} style={marginTop(1)}/>
                                                    <div style={marginLeft(1)} className={'flex1'}>{itemInfo}</div>
                                                </div>
                                            })
                                        }
                                    </div>
                                    <img src={item.img} alt={item.img}/>
                                </div>

                            </div>
                        </div>
                    })
                }
                <div style={{position: 'relative'}} className={'flex-row width100p'}>
                    <img src={' https://qiniu.mrcargo.com/zs-warehouse-bg-bottom.png'} alt={'zs-warehouse-bg-bottom'}
                         width={'100%'}/>
                    <div className={'width100p  first-context'}>
                        <div style={Object.assign(marginLeft(40), marginTop(2))}>
                            <div className={'font-size40 colorfff font-weight400'} style={marginTop(6)}>
                                <div>Contact us quickly</div>
                                <div>to get the fastest and best service</div>
                            </div>
                            <Button type="primary" shape="default" size={'large'}
                                    className={'concat-btn'}
                                    style={marginTop(5)} onClick={() => {
                                this.props.navigationRoute('/concatUs')
                            }
                            }>Need to contact </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}


